import { Component, OnInit, Input } from '@angular/core';
import { Components } from '@ionic/core';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-ongs-pet-view',
  templateUrl: './ongs-pet-view.page.html',
  styleUrls: ['./ongs-pet-view.page.scss'],
})
export class OngsPetViewPage implements OnInit {
  slidesOptions:any = {
    
  };
  pet:any = null;
  @Input() modal: Components.IonModal;
  constructor(
    public navCtrl: NavController,
    private storage: Storage
  ) { }

  ngOnInit() {
    this.storage.get('ong-pet:view').then((pet:any)=>{
      this.pet = pet;
    });
  }
  back(){
    this.modal.dismiss();
  }
}
